export const validation = {
  required: "필수 입력 항목입니다",
  number: "숫자를 입력해주세요",
  numberPositive: "양수를 입력해주세요",
  numberInteger: "정수를 입력해주세요",
};
